import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  createTheme,
  ThemeProvider,
  Button
} from "@mui/material";
import dayjs from "dayjs";
import PrimaryButton from "./primaryButton";
import SecondaryButton from "./secondaryButton";
import ThankyouIcon from '../assets/images/OBJECTS.svg'
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { handleDecodeJSON, handleEncodeJson } from "../utils/encodeDecodeJson";
import feedbackActions from "../Redux/feedback/actions";
import { useDispatch, useSelector } from "react-redux";
import useFetchCandidateTokenDetails from "../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../utils/auditLog";
import checkAuth from "./CheckAuth";

export default function ThankYou() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { heartBeat } = useSelector((state) => state.examReducer);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  let candidateData = JSON.parse(sessionStorage.getItem("candidate_details"));
  let isFeedback = candidateTokenDetails?.configuration?.feedback;
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 700,
        lg: 1200,
        xl: 1536,
      },
    },
  });
  const data = [
     {
      title: "Center Name",
      val: ` ${candidateTokenDetails?.configuration?.venueName}`,
    },
    {
      title: "Candidate Name",
      val: `:  ${candidateData?.candidateName}`,
    },
    {
      title: "Roll No",
      val: `:  ${candidateData?.rollNo}`,
    },
    {
      title: "Exam Date",
      val: `:  ${dayjs(candidateData?.startTime).format("DD MMM, YYYY")}`,
    },
  ];
useEffect(()=>{
            checkAuth(navigate)
            },[])
  const handleFeedback = async () => {
    localStorage.setItem('isInFeedback', true)
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Feedback Review",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    const formData = {
      imageSize: "L",
      language: "english",
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: feedbackActions.GET_FEEDBACK_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  const handleExit = async () => {
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Exit",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    Cookies.remove("test_engine_token");
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace(`/${Cookies.get("test_engine_project")}/login`);
  };

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          backgroundColor: "#EBF2FF",
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              p: 3,
              bgcolor: "#fff",
              textAlign: "center",
            }}
          >
            <img src={ThankyouIcon} alt="Thank you" height={150} width={150}/>
            <Typography
              sx={{
                fontWeight: "bold",
                color: "rgba(63, 65, 209, 1)",
                fontSize: "28px",
                pt: 3,
                pb: 3,
              }}
            >
              Thank you! <br/>
               Your Exam Submitted Successfully.
            </Typography>
            {data?.map((v, i) => (
              <Grid
                container
                key={i}
                p={2}
                sx={{ borderBottom: "1px solid rgba(30, 30, 30, 0.1)",color:"#1E1E1E" , display:"flex",alignItems:"center", justifyContent:{xs:"space-between",sm:"center"}}}
              >
                <>
                  <Grid
                    item
                    md={3}
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "start",
                    }}
                  >
                    {v?.title}
                  </Grid>
                  <Grid
                    item
                    md={8}
                    style={{
                      fontSize: "16px",
                      lineHeight: "17px",
                      textAlign: "start",
                      fontWeight:"400"
                    }}
                  >
                    {v?.val}
                  </Grid>
                </>
              </Grid>
            ))}
            <Grid container pt={2} spacing={3} justifyContent="center">
              <Grid item md={isFeedback ? 6 : 12} >
                <Button  onClick={handleExit} style={{color:isFeedback ? "rgba(63, 65, 209, 1)" : "white",backgroundColor:isFeedback ? "white" : "rgba(63, 65, 209, 1)",border:"1px solid rgba(63, 65, 209, 1)",borderRadius:"20px",width:"70%"}}>
                  Exit
                </Button>
              </Grid>
              {isFeedback && (
                <Grid item md={6}>
                  <Button
                    style={{color:"white",backgroundColor:"rgba(63, 65, 209, 1)",border:"1px solid rgba(63, 65, 209, 1)",borderRadius:"20px",width:"70%"}}
                    onClick={handleFeedback}
                  >
                    continue to feedback
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
